import $ from 'jquery';
import Config, {
  getCommonVisualizerType,
  IS_LIXIL_SERVERS, IS_OFFLINE_MODE,
  USE_SERVER_CACHING
} from "../config";
import {toBoolean} from "../misc/utils";
import {getCurrentLayout} from '../bvcomponents/appLayout';
import store from "../store";
import AxiosInstance from "./axiosInstance";
import {renderErrorPopup} from "./api-popups";
import {HOST_NAME} from "./api";
import {fixFeaturesResponse, getRequestRoomLayout} from "../misc/backendFunctions";
import featuresWorker from "../webWorkers/featuresWorker";
import {setResponseFeaturesMarkUp} from "../misc/markUpFunctions";

//Axios.defaults.headers.get['Content-Type'] = 'application/json';

if (!String.prototype.endsWith) {
  Object.defineProperty(String.prototype, 'endsWith', {
    value: function(searchString, position) {
      var subjectString = this.toString();
      if (position === undefined || position > subjectString.length) {
        position = subjectString.length;
      }
      position -= searchString.length;
      var lastIndex = subjectString.indexOf(searchString, position);
      return lastIndex !== -1 && lastIndex === position;
    }
  });
}

const serverConfig = document.kvConfig;
const __hideFeatures = toBoolean(serverConfig.hide) ? 1 : 0;

function _get(url, axiosController, headers) {
  return axiosController ? AxiosInstance.get(url, {
    signal: axiosController.signal
  }) : AxiosInstance.get(url, headers ? {headers} : undefined)
}

function _post(url, data, headers = null) {
  return AxiosInstance.post(url, data, headers ? {headers} : {
    headers: {
      "Content-Type": "application/json",
      'x-antiforgery-token': $('input[name=__RequestVerificationToken]').val()
    }
  });
}

let __urlBase = null;
let baseDomainUrl = null;

export function _getUrlBase() {
  if (__urlBase) return __urlBase;
  let {subDomain} = document.kvConfig;
  // let {domain} = document.kvConfig;
  // domain = domain || 'quotesflooring.com';
  subDomain = subDomain ? subDomain + '.' : '';
  __urlBase = subDomain + HOST_NAME;
  return __urlBase;
}

export const getBaseDomainUrl = () => {
  if (!baseDomainUrl) {
    if (document.location.hostname === 'localhost') {
      baseDomainUrl = document.kvConfig.domain;
    } else {
      const { hostname, protocol } = window.location;
      const domainParts = hostname.split('.');
      const baseDomain = domainParts.slice(-2).join('.');
      baseDomainUrl = `${protocol}//${baseDomain}`;
    }
  }
  return baseDomainUrl
}

function _urlBase() {
  return serverConfig.type === 'Fabricator' ? _getUrlBase() + '/Job/QuickQuote/' + serverConfig.userId : '.';
}

export const addUrlMode = (baseUrl, visualizerType = "") => {
  const visType = getCommonVisualizerType(visualizerType);
  if (IS_LIXIL_SERVERS && (document.kvConfig.visualizerType === "bvLook")) { // temporarily, until the backend is fixed
    return baseUrl
  }
  return baseUrl + (baseUrl.includes("?") ? "&" : "?") + `mode=${visType}`
}

const hardcodeResponsesFolder = () => {
  if (document.kvConfig.visualizerType === "bvLook") {
    return "node/responses/lixil"
  }
  return "node/responses"
}

export default class JsonApi {
  static allAvailableStones(jobId, type) {
    jobId = jobId || 0;
    type = type || 'Fabricator';
    return _get(`${_getUrlBase()}/api/Public/${serverConfig.userId}/AvailableStones?jobId=${jobId}&type=${type}&loadStoneFilters=true`);
    // return _get(`${_getUrlBase()}/Job/QuickQuote/${serverConfig.userId}/AvailableStones?jobId=${jobId}&type=${type}`);
  }

  static getNewQuoteData(jobId, type) {
    jobId = jobId || 0;
    type = type || 'Fabricator';
    // let url = `${_getUrlBase()}/Job/QuickQuote/${serverConfig.userId}/GetNewQuoteData?jobId=${jobId}&type=${type}&hide=${__hideFeatures}`;
    let url = `${_getUrlBase()}/api/Public/${serverConfig.userId}/GetNewQuoteData?jobId=${jobId}&type=${type}&hide=${__hideFeatures}`;
    if (Config.isMobile()) {
      url += '&w=150';
    }
    return _get(url);
  }

  static getMenuNavigation (forTool) {
    if (document.kvConfig.noInternetMode) {
      return Promise.resolve({data: []})
    }
    const url = forTool
      ? `${_getUrlBase()}/api/PublicFabricatorVisualizerNavigation/List?FabricatorId=${serverConfig.userId}&forTool=${forTool}`
      : `${_getUrlBase()}/api/PublicFabricatorVisualizerNavigation/List?FabricatorId=${serverConfig.userId}`
    return _get(url);
  }

  static userLogin(data) {
    if(document.kvConfig.kioskMode) {
      var response = this.saveUserKiosk(data);
      return Promise.resolve(response);
    } else {
      return _post(_getUrlBase() + "/api/Public/LoginClient", data);
    }
    // return _post(_urlBase() + "/LoginClient", {email: email, password: password});
  }

  static userRegister(data) {
    if(document.kvConfig.kioskMode) {
      var response = this.saveUserKiosk(data);
      return Promise.resolve(response);
    } else {
      return _post(`${_getUrlBase()}/api/Public/RegisterClient`, data);
    }
    // return _post(_urlBase() + "/RegisterClient", data);
  }

  static saveQuote(data, skipSavingDocuments = false) {
    if(document.kvConfig.kioskMode) {
      const state = store.getState();
      const {serverState, userState} = state;
      const userInfo = userState.userInfo;
      return this.saveQuoteKiosk(JSON.stringify({
        subDomain: document.kvConfig.subDomain,
        encodedUserId: userInfo.encodedUserId,
        quoteData: JSON.stringify(data),
        id: serverState.jobId
      }));
    } else {
      return _post(_getUrlBase() + "/api/Public/SaveQuote" + (skipSavingDocuments ? "?ignoreDocuments=true" : ""), data);
    }
    // return _post(_urlBase() + "/SaveMultiQuickQuote", data);
  }

  static submitPayment(data) {
    return _post(_getUrlBase() + "/api/Public/SubmitPayment", data);
  }

  // email must be post-fixed by the /, see here
  // https://stackoverflow.com/questions/13298542/apicontroller-returns-404-when-id-contains-period
  // the accepted answer
  static resetUserPassword(email, language) {
    return _post(_getUrlBase() + '/api/Public/SendResetPassword', {
      email,
      language,
      fabricatorId: document.kvConfig.userId,
    });
  }

  static scheduleCustomer(data) {
    if(document.kvConfig.kioskMode) {
      return this.saveSchedule(JSON.stringify({
        subDomain: document.kvConfig.subDomain,
        json: JSON.stringify(data)
      }));
    } else {
      return _post(_getUrlBase() + "/api/Public/Schedule", data);
    }
  }

  static getJobData(jobId) {
    return _get(_urlBase() + "/GetJobDataById?jobId=" + jobId);
  }

  static getBVJobData(jobId, editToken) {
    return _get(_getUrlBase() + '/api/Public/getBvJobData/' + jobId + (editToken ? "?editToken=" + editToken : ""))
  }

  static getEmployees() {
    if(document.kvConfig.kioskMode) {
      return Promise.resolve(this.getKioskApiResponse(document.kvConfig.userId, `/api/Public/getEmployees/${+document.kvConfig.userId}`));
    } else {
      return _get(`${_getUrlBase()}/api/Public/getEmployees/${+document.kvConfig.userId}`);
    }
  }

  static generateAuthenticationToken() {
    const userState = store.getState().userState;
    const {userInfo} = userState;
    if (userInfo && userInfo.phoneNumber && userInfo.phoneNumber.indexOf("555-555-5555") === -1) {
      return _get(_getUrlBase() + "/api/TwoFactorAuthentication/GenerateAuthenticationRequest?encodedCustomerId=" + encodeURIComponent(userState.encodedUserId));
    } else if(userInfo && userInfo.phoneNumber && userInfo.phoneNumber.indexOf('555-555-5555') !== -1) {
      return Promise.resolve("93eacff8-d2cf-488b-b10d-12c81dd806e2");
    } else {
      return Promise.reject();
    }
  }

  static sendAuthenticationRequest(token, to, type) {
    if(token !== "93eacff8-d2cf-488b-b10d-12c81dd806e2")
      return _post(_getUrlBase() + "/api/TwoFactorAuthentication/SendAuthenticationRequest", {token, to, type});
    else
      return Promise.resolve(true);
  }

  static validateAuthenticationRequest(token, code, phoneNumber) {
    const userState = store.getState().userState;
    if(token === "93eacff8-d2cf-488b-b10d-12c81dd806e2") {
      return Promise.resolve({data: code === "568127"});
    } else {
      return _post(_getUrlBase() + "/api/TwoFactorAuthentication/ValidateAuthenticationRequest", {token, code, phoneNumber, encodedCustomerId: userState.encodedUserId});
    }
  }

  static postDisplayRoom(bvState) {
    return _post(`${_getUrlBase()}/api/public/saveDefaults/${+document.kvConfig.userId}/client/bathroomvisualizer`, [bvState]);
  }

  static getDisplayRoom(forVisualizer = getCommonVisualizerType()) {
    return _get(`${_getUrlBase()}/api/public/getDefaults/${+document.kvConfig.userId}/client/${forVisualizer}visualizer`);
  }

  static resendActivationEmail(email) {
    return _post(`${_getUrlBase()}/api/public/resendActivationEmail`,
      {email, fabricatorId: +document.kvConfig.userId});
  }

  static async getBathroomVisualizerData(featuresCount, forVisualizerType) {
    const visualizerType = forVisualizerType || document.kvConfig.visualizerType;
    if (document.kvConfig.noInternetMode) {
      const featuresResponse = await _get(hardcodeResponsesFolder() + "/mainVisualizerResponseFeatures.json");
      let allResponse = await _get(hardcodeResponsesFolder() + "/mainVisualizerResponse.json");
      allResponse.data.features = featuresResponse.data;
      return allResponse
    }
    let localUrl = addUrlMode(`/api/public/bvdata/${+document.kvConfig.userId}`, visualizerType);
    let remoteUrl = visualizerType === "bvLook"
      ? addUrlMode(`/api/public/bvdata/${+document.kvConfig.userId}${(featuresCount ? "?featuresPerGroup="+featuresCount : "")}`, visualizerType)
      : addUrlMode(`/api/public/bvdata/${+document.kvConfig.userId}${(featuresCount ? "/"+featuresCount : "")}`, visualizerType)
    return document.kvConfig.kioskMode
           ?  this.getKioskApiResponse(document.kvConfig.userId, localUrl)
           :  _get(`${_getUrlBase()}${remoteUrl}`);
  }

  static getBathroomVisualizerFeatures(arrayOfIds,
                                       arrayOfSkus,
                                       requestSharedFeatureNames = false,
                                       visualizerType,
                                       searchString = "",
                                       axiosController = null,
                                       getOnlyGroupNames = null,
                                       needToCacheResponse = false) {
    // removed as we need to get wizard features to load all of them
    if (searchString && (document.kvConfig.noInternetMode || IS_OFFLINE_MODE)) { // no need to receive features, we already received 50k, all of them
      return Promise.resolve({data: []})
    }
    const baseUrl = addUrlMode(`${_getUrlBase()}/api/public/bvdata/${+document.kvConfig.userId}/features`, visualizerType);
    const payload = searchString
      ? {"Search": [searchString]}
      : arrayOfSkus
        ? requestSharedFeatureNames ? {sharedFeatureNames: arrayOfSkus} : {skus: arrayOfSkus}
        : {Ids: arrayOfIds};
    if (getOnlyGroupNames) {
      payload.featureGroups = getOnlyGroupNames;
    }
    if (needToCacheResponse) {
      payload.cacheResponse = true;
    }
    if (axiosController) {
      return AxiosInstance.post(baseUrl, payload, {signal: axiosController.signal})
    }
    return _post(baseUrl, payload);
  }

  static getBathroomVisualizerGroups(visualizerType) {
    if (document.kvConfig.noInternetMode) {
      return _get(hardcodeResponsesFolder() + "/featureGroupsCounts.json")
    }
    const localUrl = addUrlMode(`/api/public/bvdata/${+document.kvConfig.userId}/groups`, visualizerType);
    return document.kvConfig.kioskMode
           ?  this.getKioskApiResponse(document.kvConfig.userId, localUrl)
           :  _get(`${_getUrlBase()}${localUrl}`);
  }

  static fixGroupName(groupName) {
    return groupName.trim().replace(/\//g,"%23%23").replace(/ /g,"%20").replace(/&/g,"%26");
  }

  static async getBathroomVisualizerGroupFeatures(groupName,
                                                  page = 0,
                                                  pageSize = 1000,
                                                  filterValues = [],
                                                  searchText = "",
                                                  layoutAbbreviation = "",
                                                  axiosController,
                                                  requestOldFeatures = false,
                                                  visualizerType = document.kvConfig.visualizerType) {

    if (IS_OFFLINE_MODE && (filterValues.length || searchText)) { // still make a request to get features from quotingtool
      return {data: []}
    }

    pageSize = (groupName === "EX L") ? 1500 : pageSize;
    const fixedGroupName = JsonApi.fixGroupName(groupName);
    const layout = getCurrentLayout();

    const isKitchen = visualizerType === "kvScene";

    let localUrl = layout.isNewLayout && (isKitchen && !IS_LIXIL_SERVERS)
      ? `/api/public/bvdataR/${+document.kvConfig.userId}/features/${fixedGroupName}`
      : `/api/public/bvdata/${+document.kvConfig.userId}/features/${fixedGroupName}`;

    let requestUrl = `${_getUrlBase()}${localUrl}/${page}/${pageSize}/`;

    const searchGroupName = layout.isNewLayout && groupName.includes(" Crop") ? groupName.replace(" Crop", "") : groupName;
    const featureGroup = layout.getFeatureGroupByGroupName(searchGroupName);

    requestUrl += getRequestRoomLayout(layout, featureGroup, layoutAbbreviation, requestOldFeatures); // should go before filters

    requestUrl = addUrlMode(requestUrl, visualizerType);

    if (filterValues.length) {
      filterValues.forEach((filterValue) => {
        requestUrl += (requestUrl.includes("?") ? "&" : "?") + "filterId=" + filterValue;
      });
    }
    if (searchText) {
      requestUrl += (requestUrl.includes("?") ? "&" : "?") + "filter=" + searchText
    }

    const fabricatorSettings = store.getState().fabricatorState.settings;
    if (fabricatorSettings.leadCapture) {
      requestUrl += (requestUrl.includes("?") ? "&" : "?") + "sortBy=unlocked";
    }
    if (requestOldFeatures) {
      const oldVersion = getCommonVisualizerType(visualizerType) === "kitchen" ? "kv4" : "bv4";
      requestUrl += (requestUrl.includes("?") ? "&" : "?") + "toolVersion=" + oldVersion; // should go before filters
    }

    if (groupName && !requestOldFeatures && !searchText && !filterValues.length) {
      try {
        // wait 1 minute in offline mode, as
        const cachedResponse = await featuresWorker.getFeaturesWorkerCachedFeatures(groupName, page, requestUrl);
        if (cachedResponse) {
          if (cachedResponse.markUpResponse) {
            const storeState = store.getState();
            return {
              data: setResponseFeaturesMarkUp(cachedResponse.dbFeatures, cachedResponse.markUpResponse, storeState),
              markUpAlreadySet: true,
            }
          }
          return {data: cachedResponse.dbFeatures}
        }
        // console.log("received after waiting", cachedResponse);
      } catch (e) {
        console.log("Group did not resolve in time", e);
      }
    }

    const response = document.kvConfig.kioskMode
      ? await this.getKioskApiResponse(document.kvConfig.userId, localUrl, {filterValues, searchText, page, pageSize, type: "features" })
      : await _get(requestUrl, axiosController)
    if (Config.isDevMode()) {
      console.log(requestUrl + " regular response:", response);
    }
    if (!response || !response.data || response.data.error) {
      renderErrorPopup(response.data.error);
      return {data: []}
    }
    return {data: fixFeaturesResponse(response.data)}
  }

  static getBathroomVisualizerGroupFilterValues(groupName = "", filterId = null, withStoneFilters = true) {
    if (document.kvConfig.noInternetMode || IS_OFFLINE_MODE) { // no need to receive features, we already received 50k, all of them
      return Promise.resolve({data: []})
    }
    const fixedGroupName = JsonApi.fixGroupName(groupName);
    var localUrl = `/api/public/bvdata/${+document.kvConfig.userId}/filters/${fixedGroupName}/`;
    var featureLocal = `/api/public/bvdata/${+document.kvConfig.userId}/features/${fixedGroupName}`;
    // const layout = getCurrentLayout();
    if (USE_SERVER_CACHING) {
      localUrl += `ALL/`;
    }
    localUrl = addUrlMode(localUrl);
    featureLocal = addUrlMode(featureLocal);
    let requestUrl = `${_getUrlBase()}${localUrl}`;
    if (filterId) {
      requestUrl = requestUrl + filterId
    }
    if (!withStoneFilters) {
      requestUrl = requestUrl + (requestUrl.includes("?") ? "&" : "?") + "stoneFilters=false";
    }

    if(document.kvConfig.kioskMode) {
      return this.getKioskApiResponse(document.kvConfig.userId, localUrl, {type: 'filters', filterId, featureLocal});
    } else {
      return _get(requestUrl);
    }
  }

  static getQtCategories(layoutName, forVisualizerType) {
    if (document.kvConfig.noInternetMode) {
      return _get(hardcodeResponsesFolder() + "/featureGroupCategories.json")
    }
    const featuresPerGroupAmount = window.location.href.includes("cutting_edge_countertops")
    || (document.kvConfig.userId === 138452) ? 200 : 50;
    const visualizerType = getCommonVisualizerType(forVisualizerType);
    // return _get(`${_getUrlBase()}/api/public/featureGroupCategories/${+document.kvConfig.userId}/${visualizerType}/?featuresPerGroup=${featuresPerGroupAmount}&mode=${visualizerType}&layout=${layoutName}`);

    const layout = getCurrentLayout(forVisualizerType);
    const localUrl = layout.isNewLayout
      ? `/api/public/featureGroupCategoriesLite/${+document.kvConfig.userId}/${visualizerType}/`
      : `/api/public/featureGroupCategories/${+document.kvConfig.userId}/${visualizerType}/?featuresPerGroup=${featuresPerGroupAmount}&mode=${visualizerType}&layout=${layoutName}`;
    return document.kvConfig.kioskMode
           ?  this.getKioskApiResponse(document.kvConfig.userId, localUrl)
           :  _get(`${_getUrlBase()}${localUrl}`);
  }

  static saveQuoteFast(data) {
    if(document.kvConfig.kioskMode) {
      return Promise.resolve(this.getKioskData("quickSave", JSON.stringify({
        id: data.jobId,
        saveData: data.data
      })));
    }
    else {
      return _post(`${_getUrlBase()}/api/public/SaveQuoteFast`, data);
    }
  }

  static contractSign(data) {
    return _post(`${_getUrlBase()}/api/public/replace-and-sign`, data);
  }

  static getDocumentForJob(jobId, forceNew = false) {
    return _post(`${_getUrlBase()}/api/public/document-for-job/${jobId}/${forceNew}`, {});
  }

  static getContractDocuments(fabricatorId = document.kvConfig.userId) {
    return _get(`${_getUrlBase()}/api/document-signing/documents/${fabricatorId}`);
  }

  static getDocumentForFabricator(fabricatorId = document.kvConfig.userId) {
    if (document.kvConfig.noInternetMode) {
      return _get(hardcodeResponsesFolder() + "/documentsForFabricator.json")
    }
    return _post(`${_getUrlBase()}/api/public/document-for-fab/${fabricatorId}/`);
  }

  static getFabricatorSubscriptions(fabricatorId) {
    if (document.kvConfig.noInternetMode) {
      return _get(hardcodeResponsesFolder() + "/fabricatorSubscriptions.json")
    }
    const localUrl = `/api/public/GetFabricatorSubscriptionInfo/${fabricatorId}`;
    return document.kvConfig.kioskMode
           ?  this.getKioskApiResponse(fabricatorId, localUrl)
           :  _get(`${_getUrlBase()}${localUrl}`);
  }

  static getFabricatorDiscounts(fabricatorId) {
    if (document.kvConfig.noInternetMode) {
      return _get(hardcodeResponsesFolder() + "/fabricatorDiscounts.json")
    }
    return _get(`${_getUrlBase()}/api/public/fabricator-discounts/${fabricatorId}`);
  }

  static async getKioskApiResponse(fabricatorId, localUrl, otherData = null) {
    let data = {
      fabricatorId,
      localUrl,
      additionalInfo: {...otherData}
    };
    return this.getKioskData("getJson", data);
  }

  static async getKioskData(type, data) {
    var kioskData = await this.getRawKioskData(type, data);
    if(typeof(kioskData) == "string") {
      kioskData = JSON.parse(kioskData);
    }
    return {data: kioskData};
  }

  static getRawKioskData(type, data) {
    var kioskData = KioskApp.PostMessage({
      type,
      data
    });
    return kioskData;
  }

  static saveQuoteKiosk(data) { return this.getKioskData('saveQuote', data); }
  static saveUserKiosk(data) { return this.getKioskData('saveUser', data); }
  static saveSchedule(data) { return this.getKioskData('schedule', data); }

  static getCustomersAndEmployees(fabricatorId = document.kvConfig.userId) {
    if (document.kvConfig.noInternetMode) {
      return _get(hardcodeResponsesFolder() + "/customersAndEmployees.json")
    }
    return _get(`${_getUrlBase()}/api/public/fabricator-customer-employees/${fabricatorId}/`);
  }

  static getCustomerById(customerId) {
    return _get(`${_getUrlBase()}/api/public/getCustomerData/${customerId}?format=json`);
  }
  static copySqftImages(fabricatorId, postData) {
    return _post(`${_getUrlBase()}/api/public/copySqftImages/${fabricatorId}/`, postData);
  }
  static getPassedUserInfo(userData) {
    return _post(`${_getUrlBase()}/api/public/EncSSOLoginClient/`, userData);
  }
  static postSaveVisualizerImage(fabricatorId, postData) {
    return _post(`${_getUrlBase()}/api/public/saveVisualizerImage/${fabricatorId}`, postData);
  }
  static postSaveTempData(postData, id = "", expiresIn = "") {
    let postString = `${_getUrlBase()}/api/public/saveTempData`;
    if (id) {
      postString+= `/${id}`;
    }
    if (expiresIn) {
      postString+= `/${expiresIn}`;
    }
    return _post(postString, {"data": postData});
  }
  static getSaveTempData(id = "") {
    return _get(`${_getUrlBase()}/api/public/getTempData/${id}`);
  }
  static postSureTax(postData, fabricatorId = document.kvConfig.userId) {
    return _post(`${_getUrlBase()}/api/public/postSureTaxRequest/${fabricatorId}`, postData);
  }
  static postVerifyAddress(postData) {
    return _post(`${_getUrlBase()}/api/public/verifyAddress`, postData);
  }
  static getTrumbleShippingOptions(skuList, zipCode) {
    return _get(`${_getUrlBase()}/api/public/getTrumbleShippingOptions/${skuList}/${zipCode}`);
  }
  static postTrumbleShippingOptions(postData, zipCode) {
    return _post(`${_getUrlBase()}/api/public/trumbleShippingOptions/${zipCode}`, postData);
  }
  static postTrumbleInventory(postData) {
    return _post(`${_getUrlBase()}/api/public/trumbullInventory`, postData);
  }
  static postShipperHqShipping(postData) {
    return _post(`${_getUrlBase()}/api/public/shipperHqShipping`, postData);
  }
  static getFilterGroups(fabricatorId = null) {
    // fabricatorId returns fabricator filters only! QCDES-6413 issue
    return _get(fabricatorId
      ? `${_getUrlBase()}/api/public/filterGroups/${fabricatorId}`
      : `${_getUrlBase()}/api/public/filterGroups`
    );
  }
  static getMarkUpForFeatures(featuresArray) {
    return _post(`${_getUrlBase()}/api/markup/get-features/`, featuresArray);
  }
  static loginAdmin(data) {
    return _post(`${_getUrlBase()}/api/admin-edit/token`, data);
  }
  static postEditFeatures(data, headers) {
    return _post(`${_getUrlBase()}/api/admin-edit/${document.kvConfig.userId}/update-features`, data, headers);
  }
  static setShipToAddress(data, headers) {
    return _post(`${_getUrlBase()}/api/public/setShipToAddress`, data, headers);
  }
  static getShipToAddress(headers) {
    return _get(`${_getUrlBase()}/api/public/getShipToAddress/${document.kvConfig.jobId}`, null, headers);
  }
  static postGenerateAiRequest(data, headers) {
    return _post(`${_getUrlBase()}:7122/api/ImageProcessing/convert`, data, headers);
  }
  static postSaveJobDocument(data) {
    return _post(`${_getUrlBase()}/api/public/saveJobDocument`, data);
  }
}
